// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { userMixins } from "@/app/mixins/modules/user-mixins.js";

// Service
import UserService from "@/app/services/main/user/user-service";
import PaymentService from "@/app/services/main/payment/payment-service";
import PetOrderService from "@/app/services/main/pet-order/pet-order-service";

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";
import { STATES } from "@/app/constants/state-constants.js";

export default {
  name: "DogPurchaseTransactionSuccess",
  components: {},
  directive: {},
  filters: {},
  mixins: [dateMixins, toastMessageMixins, userMixins],
  props: {
    dogPurchaseDetails: {
      required: true,
      default: null,
    },
    successTitle: {
      type: String,
      default: "Congratulations, your purchase has been approved!",
    },
    subTitle: {
      type: String,
      default: "",
    },
    
  },
  data() {
    return {
      isAPILoading: false,
      state: this.dogPurchaseDetails
        ? STATES[this.dogPurchaseDetails.state]
        : "",
      havePetId: !!this.dogPurchaseDetails.petId,
      termsAndConditions: false,
      isAgreed: true,
    };
  },
  
  computed: {
    showInformationSteps() {
      this.havePetId = !!this.dogPurchaseDetails.petId;
      return (
        this.$route.name === "Dog Purchase Success" ||
        this.$route.name === "Dog Purchase Transaction"
      );
      
    },
    isNativeApp() {
      return this.$store.getters.getIsNativeApp;
    },
    isUserLoggedIn() {
      return !!this.$store.getters.getUserToken;
    },
  },
  watch: {
    termsAndConditions() {
      if (this.termsAndConditions === false) {
        this.isAgreed = false;
        return;
      }
      this.isAgreed = true;
    },
  },
  mounted(){
    const {id, dogName, totalAmount, } = this.dogPurchaseDetails;

    window.LatitudeCheckout = {
      "merchantId": process.env.VUE_APP_MERCHANT_ID,
      "page": "product",
      "container": "latitude-banner-container",
      "containerClass": "",
      "currency": "AUD",
      "minAmount": "",
      "layout": "inversed",
      "paymentOption": "equal",
      "promotionMonths": "24",
      "product": {
          "id": id,
          "name": `${dogName} and product shop credit`,
          "category": "Dog Purchase",
          "price": totalAmount,
          "sku": id
      }
  };

  this.createLatitudeScript();
  },
  methods: {
    createLatitudeScript(){
      const script = document.createElement("script");
      script.src = `${process.env.VUE_APP_MERCHANT_URL}${process.env.VUE_APP_MERCHANT_ID}`
      document.body.appendChild(script);    
    },
    showEmail(email) {
      if (email) {
        window.location.href = `mailto:${email}`;
      }
    },
    addPetToList() {
      const dogPurchaseDetails = {
        referenceNumber: this.$route.query.referenceId,
        token: this.$route.query.token,
      };

      PetOrderService.addDogPurchasePet(dogPurchaseDetails)
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
            this.havePetId = true;

            this.showCustomSuccessToast(
              null,
              `Successfully added ${this.dogPurchaseDetails.name} as one of your pets.`
            );

            this.getUserDetailsAPIThenSwitchPet();
            this.$forceUpdate();
          } else {
            this.showAPIErrorToast("Unable to add pet to profile.", res);
          }
        })
        .catch(() => {
          this.showGenericErrorToast();
        })
        .finally(() => {
          this.isAPILoading = false;
        });
    },
    getUserDetailsAPIThenSwitchPet() {
      const { emailAddress } = this.getUserDetails();

      // lmdc get logged in user api
      UserService.getLoggedInUser(emailAddress).then((res) => {
        if (res.status === STATUS_CODES.SUCCESS) {
          this.$store.commit("setUserDetails", res.data.userDetails);

          // switch pet
          this.$store.commit(
            "setActivePet",
            this.getUserPets[this.getUserPets.length - 1]
          );
          EventBus.$emit("petSwitched");
        } else {
          this.showGenericErrorToast();
        }
      });
    },
    createAccount() {
      const referenceId = this.$route.query.referenceId;
      this.isAPILoading = true;
      UserService.postCreateUser({ referenceId })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            this.$swal({
              imageHeight: "30px",
              imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
              imageAlt: "Success Dog",
              title: "Awesome!",
              text: "Please check your email for verification.",
              confirmButtonColor: "#4B8BFF",
              confirmButtonText: "Got it",
            });
          } else {
            this.showAPIErrorToast("Unable to create an account.", res);
          }
        })
        .catch(() => {
          this.showGenericErrorToast();
        })
        .finally(() => {
          this.isAPILoading = false;
        });
    },
    contactUsEmail() {
      window.location.href = "mailto:services@lovemydogclub.com.au";
    },
    proceedToLatitude() {
      const { referenceId, token } = this.$route.query;

      if (!this.termsAndConditions) {
        this.showCustomErrorToast(null, "You must agree to the Privacy and Consumer Policy to proceed.");
        this.isAgreed = false;
        return;
      }
      
      this.isAPILoading = true;
      PaymentService.proceedToLatitudeInterestFree({ referenceId, token })
        .then((res) => {
          if (res.status === STATUS_CODES.SUCCESS) {
            if (res.data && res.data.data.length > 0) {
              const { redirectUrl } = res.data.data[0];
              this.$swal({
                title: "Redirecting to ...",
                html: `<img style='width: 300px' src=${require("@/assets/images/_shared/latitude-interest-free-logo.svg")}>`,
                allowOutsideClick: false,
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false,
              }).then(() => {
                window.location = redirectUrl;
              });
            } else {
              this.showGenericErrorToast();
            }
          } else {
            this.showAPIErrorToast("Unable to process your purchase.", res);
          }
        })
        .catch(() => {
          this.showGenericErrorToast();
        })
        .finally(() => {
          this.isAPILoading = false;
        });
    },
    mobileNumberFormat(mobileNumber) {
      if (mobileNumber) {
        let data = mobileNumber.split("");
        data.splice(4, 0, "-");
        return data.join("");
      } else {
        return "";
      }
    },
  },
};
